import { ACTIVATION_ACTION } from "./event.index.js";

/**
 *
 *
 */
export const SHEET_ACTION_CLOSE_BUTTON = [ACTIVATION_ACTION.CLOSE_BUTTON, "closedWithX"] as const;

/**
 *
 *
 */
export const SHEET_ACTION_BACK_BUTTON = [
  ACTIVATION_ACTION.BACK_BUTTON,
  "closedWithBackNavigation",
] as const;

/**
 *
 *
 */
export const SHEET_ACTION_BACK_DROP = [
  ACTIVATION_ACTION.BACK_DROP,
  "closedWithCurtainClick",
] as const;

/**
 *
 *
 *
 *
 */
export const SHEET_ACTION_DRAG_DOWN = [ACTIVATION_ACTION.DRAG_DOWN, "closedWithDrag"] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_ESCAPE_KEY = [ACTIVATION_ACTION.ESCAPE_KEY, "closedWithEscape"] as const;

/**
 *
 *
 *
 *
 */
export const SHEET_ACTION_PROGRAMMATICALLY = [
  ACTIVATION_ACTION.PROGRAMMATICALLY,
  "closedProgrammatically",
] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_USER_AGENT = [
  ACTIVATION_ACTION.USER_AGENT,
  "closedWithUserAgent",
] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_PAGE_ENTRY_URL = [
  ACTIVATION_ACTION.PAGE_ENTRY_URL,
  "page-entry-url",
] as const;

/**
 *
 *
 */
export type ActivationAction =
  | typeof SHEET_ACTION_CLOSE_BUTTON
  | typeof SHEET_ACTION_BACK_BUTTON
  | typeof SHEET_ACTION_BACK_DROP
  | typeof SHEET_ACTION_DRAG_DOWN
  | typeof SHEET_ACTION_ESCAPE_KEY
  | typeof SHEET_ACTION_PROGRAMMATICALLY
  | typeof SHEET_ACTION_USER_AGENT
  | typeof SHEET_ACTION_PAGE_ENTRY_URL;

/**
 *
 */
export type OcSheetV1CloseTypes =
  | (typeof SHEET_ACTION_CLOSE_BUTTON)[1]
  | (typeof SHEET_ACTION_BACK_BUTTON)[1]
  | (typeof SHEET_ACTION_BACK_DROP)[1]
  | (typeof SHEET_ACTION_DRAG_DOWN)[1]
  | (typeof SHEET_ACTION_ESCAPE_KEY)[1]
  | (typeof SHEET_ACTION_PROGRAMMATICALLY)[1]
  | (typeof SHEET_ACTION_USER_AGENT)[1]
  | (typeof SHEET_ACTION_PAGE_ENTRY_URL)[1];
